import { render, staticRenderFns } from "./MenuItemTree.vue?vue&type=template&id=19129f13&scoped=true"
import script from "./MenuItemTree.vue?vue&type=script&lang=js"
export * from "./MenuItemTree.vue?vue&type=script&lang=js"
import style0 from "./MenuItemTree.vue?vue&type=style&index=0&id=19129f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19129f13",
  null
  
)

export default component.exports